<template>
    <div class="l-content__block c-model-detail">
        <div class="c-model-detail__main">
            <div v-if="talentDetail['thumbnail_file_path']" class="c-model-detail__main-img">
                <webp-picture :webp="talentDetail['thumbnail_webp_path']">
                    <a v-if="is_indicate_toggle" :href="talentDetail['ITEM_URL']" class="thumbnail-link">
                        <img loading="eager" :src="talentDetail['thumbnail_file_path']" :alt="talentDetail['name']" fetchpriority="high">
                    </a>
                    <img loading="eager" v-if="!is_indicate_toggle" :src="talentDetail['thumbnail_file_path']" :alt="talentDetail['name']" fetchpriority="high" width="240" height="240">
                </webp-picture>
            </div>

            <p class="c-model-profile__main-name-en" v-html="talentDetail['name_kana']"></p>
            <p class="c-model-profile__main-name" v-html="talentDetail['name']"></p>
            <div v-if="is_indicate_toggle" class="toggle" :class="{ 'is-active': toggle }" @click="toggle = !toggle">
                <span v-if="toggle">折りたたむ</span>
                <span v-else>続きを読む</span>
            </div>
            <div v-if="toggle" class="sns">
                <ul>
                    <!-- HPアイコン 20210629 GRAJAPA_2020-871でトルツメ
                    <li class="footer__sns-item" v-if="talentDetail['homepage']">
                        <a :href="talentDetail['homepage']" target="_blank"> <img src="/src/assets/img/common/footer__homepage.svg" alt=""></a>
                    </li>
                    end:HPアイコントルツメ-->
                    <li class="footer__sns-item" v-if="talentDetail['instagram']">
                        <a :href="talentDetail['instagram']" target="_blank" onclick="sendGaEvent('out_instagram_talent')"> <img src="/src/assets/img/common/footer__instagram.png" alt=""></a>
                    </li>
                    <li class="footer__sns-item" v-if="talentDetail['twitter']">
                        <a :href="talentDetail['twitter']" target="_blank" onclick="sendGaEvent('out_twitter_talent')"> <img src="/src/assets/img/common/footer__x.svg" alt=""></a>
                    </li>
                    <li class="footer__sns-item" v-if="talentDetail['tiktok']">
                        <a :href="talentDetail['tiktok']" target="_blank"> <img src="/src/assets/img/common/footer__tiktok.svg" alt=""></a>
                    </li>
                    <li class="footer__sns-item" v-if="talentDetail['youtube']">
                        <a :href="talentDetail['youtube']" target="_blank"> <img src="/src/assets/img/common/footer__youtube.png" alt=""></a>
                    </li>
                    <li class="footer__sns-item" v-if="talentDetail['facebook']">
                        <a :href="talentDetail['facebook']" target="_blank"> <img src="/src/assets/img/common/footer__facebook.png" alt=""></a>
                    </li>
                    <li class="footer__sns-item" v-if="talentDetail['blog']">
                        <a :href="talentDetail['blog']" target="_blank"> <img src="/src/assets/img/common/blog.png" alt=""></a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- c-model-main -->
        <div v-if="toggle" class="c-model-detail__content">
            <div class="c-model-info">
                <div class="favorite-btn">
                    <a @click="liked = !liked" :class="{'active' : liked}" v-on:click="updateFavorite"><span>お気に入り</span></a>
                </div>
                <dl v-if="talentDetail['birthday']">
                    <dt>生年月日</dt>
                    <dd>{{ talentDetail['format_birthday'] }}</dd>
                </dl>
                <dl v-if="talentDetail['hometown']">
                    <dt>出身地</dt>
                    <dd>{{ talentDetail['hometown'] }}</dd>
                </dl>
                <dl v-if="talentDetail['blood']">
                    <dt>血液型</dt>
                    <dd>{{ talentDetail['blood'] }}</dd>
                </dl>
                <dl v-if="talentDetail['height'] || talentDetail['three_size']">
                    <dt>サイズ</dt>
                    <dd>
                        <span v-if="talentDetail['height']"><span v-html="talentDetail['height']"></span></span>
                        <span v-if="talentDetail['three_size']"><span v-html="talentDetail['three_size']"></span></span>
                    </dd>
                </dl>
            </div>
            <!-- infomation -->
            <p class="c-name" v-html="talentDetail['comment']"></p>
            <p class="c-embed" v-html="talentDetail['embed_html']"></p>
            <p class="c-date">最終更新：{{ talentDetail['format_modified'] }}</p>
        </div>
    </div>
    <!-- l-content__block -->
</template>

<script>
import axios from 'axios';

export default {
    props: [
        'talentDetail',
        'image_path',
        'is_special'
    ],
    data () {
        return {
            liked: false,
            is_indicate_toggle: this.is_special,
            toggle: !this.is_special,
        }
    },
    computed: {
        windowWidth() {
            return this.getWindowWidth();
        }
    },
    mounted(){
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth());

            // お気に入り
            const isLike = this.talentDetail['is_like'];
            this.liked  = isLike;
        })
    },
    methods:{
        getWindowWidth(event) {
            let breakpoint = document.documentElement.clientWidth;
            if(breakpoint < 767){
                this.isShow = true;
            }
        },

        // 非同期でお気に入り更新
        updateFavorite() {
            let isLiked;
            if (this.liked == true) {
                isLiked = 'like'
            } else {
                isLiked = 'unlike'
            }
            var self = this;
            let name_encoded = encodeURI(self.talentDetail['name']);

            axios.post('/mypage/favorite/edit/'+isLiked+'?id='+self.talentDetail['id']+'&name='+name_encoded, {
            })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.c-name {
    overflow-wrap: break-word;
}

.toggle {
    text-align: center;
    font-weight: bold;
    margin: 15px 0 0;

    span {
        display: inline-block;
        position: relative;
        vertical-align: text-top;
        cursor: pointer;
        font-size: 14px;

        &::after {
            display: inline-block;
            vertical-align: middle;
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 7px 0 7px;
            border-color: #222 transparent transparent transparent;
            margin: 0 0 0 5px;
        }
    }

    &.is-active {
        span {
            &::after {
                border-width: 0 7px 10px 7px;
                border-color: transparent transparent #222 transparent;
            }
        }
    }
}

.thumbnail-link {
    width: 100%;
    height: 100%;
}

.c-model-detail__main-img img {
    width: 100%;
    height: auto;
}
</style>
